import angular from 'angular';
import $ from 'jquery';
import _ from 'lodash';

import directiveWfChartHtmlUrl from '../views/directive_wfChart.html';

angular.module('workflows.directives', []);

angular.module('workflows.directives')
    .directive('wflowchart', ['$timeout', '$rootScope', 'anchorSmoothScroll', '$location', function($timeout, $rs, anchorSmoothScroll, $location) {
        return {
            restrict: 'EA',
            scope: {
                "wfruleSet": "=",
                "workflowInfo": "=",
                "workflowSearch": "=",
                "workflowSortBy": "="
            },
            templateUrl: directiveWfChartHtmlUrl,
            link: function(scope, iElement, iAttrs) {

                scope.$watch('workflowSortBy', function(nV, oV) {
                    if (nV !== oV) {
                        if(nV == "Action"){
                            scope.ruleSets = _.sortBy(scope.ruleSets, ['workflow_action_name']);
                        }else if(nV == "Status"){
                            scope.ruleSets = _.sortBy(scope.ruleSets, ['status_name']);
                        }
                        graphGenerator();
                    }
                });
                function graphGenerator() {
                    $timeout(function() {
                        _.each(scope.ruleSets, function(ruleSet) {
                            ruleSet.workflowActionName = ruleSet.workflow_action_name;
                            ruleSet.statusName = ruleSet.status_name;
                            if (ruleSet.routing_conditions.length) {
                                _.each(ruleSet.routing_conditions, function(condition) {
                                    var hrObj = $("#io-seperator-" + condition.id);
                                    var conditionObj = $("#io-condition-" + condition.id);
                                    var conditionHight = conditionObj.outerHeight(true);
                                    var hrHight = hrObj.outerHeight(true);
                                    var newTop = (hrObj.position().top + (hrHight / 2) - (conditionHight / 2)) - 10;
                                    $('#io-condition-' + condition.id).css('top', newTop + 'px');
                                    var pos = newTop - 40;
                                    //$('#io-bg-condition-' + condition.id).css('background-position', '0 '+ pos + 'px');
                                })
                            }
                        });
                    }, 1000);
                }
                var ruleSet = $rs.$on('ruleSetChange', function(event) {
                    scope.ruleSets = [];
                    scope.ruleSets = scope.wfruleSet;
                    graphGenerator();
                });

                scope.editRuleSet = function(ruleSetId) {
                    $rs.$broadcast('EDIT_RULE_SET', ruleSetId);
                }

                scope.editCondition = function(ruleSetId, condition) {
                    $rs.$broadcast('CREATE_CONDITION', ruleSetId, condition);
                };

                scope.editRule = function(ruleSetId, rule) {
                    $rs.$broadcast('CREATE_RULE', ruleSetId, rule);
                }

                scope.editTask = function(event, ruleId, taskId) {
                    event.stopPropagation();
                    //event.preventDefault();
                    $rs.$broadcast('createTask', ruleId, taskId);
                }

                scope.editLock = function(ruleSetId, lock) {
                    $rs.$broadcast('createWorkflowTaskInterlocking', ruleSetId, lock.routing_rule_id, lock.id);
                }

                scope.$on('$destroy', function() {
                    ruleSet();
                });

                scope.goto = function(event, id) {
                    event.stopPropagation();
                    $location.hash(id);
                    anchorSmoothScroll.scrollTo(id);
                    $timeout(function() {
                        $location.hash('');
                    }, 1000);
                }
            }
        };
    }])
    .directive('ioDraggable', function() {
        return function(scope, element) {
            // this gives us the native JS object
            var el = element[0];

            el.draggable = true;

            el.addEventListener(
                'dragstart',
                function(e) {
                    e.dataTransfer.effectAllowed = 'move';
                    e.dataTransfer.setData('text/plain', this.id);
                    this.classList.add('drag');
                    return false;
                },
                false);
        }
    })
    .directive('ioDroppableRule', ['$rootScope', function($rs) {
        return {
            scope: {},
            link: function(scope, element) {
                // again we need the native object
                var el = element[0];
                el.addEventListener(
                    'drop',
                    function(e) {
                        e.preventDefault();
                        e.stopPropagation();
                        var item = e.dataTransfer.getData('text/plain');
                        switch (e.dataTransfer.getData('text/plain')) {
                            case 'rule':
                                $rs.$broadcast('CREATE_RULE', e.currentTarget.id);
                                break;
                            case 'condition':
                                $rs.$broadcast('CREATE_CONDITION', e.currentTarget.id);
                                break;
                        };
                        return false;
                    },
                    false);
                el.addEventListener(
                    'dragover',
                    function(e) {
                        e.preventDefault();
                        return false;
                    },
                    false);
            }
        }
    }])
    .directive('ioDroppable', ['$rootScope', function($rs) {
        return {
            scope: {},
            link: function(scope, element) {
                // again we need the native object
                var el = element[0];
                el.addEventListener(
                    'drop',
                    function(e) {
                        var target = e.currentTarget;
                        e.preventDefault();
                        e.stopPropagation();
                        if (target && target.dataset && target.dataset.ruleset) {
                            if (e.dataTransfer.getData('text/plain') == 'task') {
                                if (target.dataset.rule) {
                                    $rs.$broadcast('createTask', target.dataset.rule);
                                }
                            } else if (e.dataTransfer.getData('text/plain') == 'rule') {
                                $rs.$broadcast('CREATE_RULE', target.dataset.ruleset);
                            } else if (e.dataTransfer.getData('text/plain') == 'condition') {
                                $rs.$broadcast('CREATE_CONDITION', target.dataset.ruleset);
                            } else if (e.dataTransfer.getData('text/plain') == 'interlocking') {
                                if (target.dataset.rule) {
                                    $rs.$broadcast('createWorkflowTaskInterlocking', target.dataset.ruleset, target.dataset.rule);
                                }
                            }
                        }
                        return false;
                    },
                    false);
                el.addEventListener(
                    'dragover',
                    function(e) {
                        e.preventDefault();
                        return false;
                    },
                    false);
            }
        }
    }]);